<template>
  <qx-card-form title="调度信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="split"></section>
      <section slot="followUp">
        <FollowUp />
      </section>
      <section slot="chooseVehicle" slot-scope="prop" class="choose-flex">
        <ChooseVehicle
          style="display: inline-block"
          :isRadio="true"
          v-model="prop.form.chooseVehicle"
          @change="() => handleVehicleChange()"
        />
        <span style="margin-left: 16px" v-if="prop.form.chooseVehicle">
          {{ prop.form.chooseVehicle.vehicleClassName
          }}{{
            prop.form.chooseVehicle.vehicleStatusName
              ? '/' + prop.form.chooseVehicle.vehicleStatusName
              : ''
          }}{{
            prop.form.chooseVehicle.vehicleLengthName
              ? '/' + prop.form.chooseVehicle.vehicleLengthName
              : ''
          }}{{ prop.form.chooseVehicle.licenceType == 2 ? '/牵引车' : '' }}
        </span>
      </section>
      <section slot="chooseDriver" slot-scope="prop" class="choose-flex">
        <ChooseDriver
          style="display: inline-block"
          :isRadio="true"
          v-model="prop.form.chooseDriver"
          @change="handleDriverChange"
        />
        <span
          style="margin-left: 16px"
          v-if="prop.form.chooseDriver && prop.form.chooseDriver.loginAcct"
          >{{ prop.form.chooseDriver.loginAcct }}</span
        >
      </section>
      <span slot="isNeedBillTip" slot-scope="scope">
        <span class="error" v-if="scope.form.isNeedBill === '2'">
          （收票主体：{{
            defaultBillData && defaultBillData.billInfo
              ? defaultBillData.billInfo.billLookUp.length > 15
                ? defaultBillData.billInfo.billLookUp.substring(0, 15) + '..'
                : defaultBillData.billInfo.billLookUp
              : '未指定默认收票主体'
          }}）
        </span>
      </span>
      <section
        slot="contractChart"
        slot-scope="prop"
        style="margin-left: 30px; margin-top: 10px"
      >
        <Contract
          ref="contract"
          :chartData="otherFormData"
          :paymentWay="Number(prop.form.paymentWay)"
        />
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getEnumList,
} from 'api';
import {
  getDefaultBillInfo,
} from 'api/operate';
import ChooseDriver from 'components/choose/driver';
import ChooseVehicle from 'components/choose/vehicle';
import Contract from 'components/contract';
import FollowUp from '../followUp';
import assignStaff from './assignStaff';
import assignFleet from './assignFleet';
import assignVehicle from './assignVehicle';
import {
  adjustData,
} from '@qx/utils/index';
export default {
  components: {
    ChooseDriver,
    ChooseVehicle,
    FollowUp,
    Contract,
  },
  data () {
    return {
      otherFormData: {
        localUserInfo: {},
        tenantInfo: {},
        // 给图表用的
        lineInfo: {},
      },
      baseForm: {
        paymentWayOptions: [],
        isNeedBillOptions: [],
        appointWayOptions: [],
        inline: true,
        form: [
          {
            label: '调度方式',
            value: 'appointWay',
            type: 'radio',
            disabled: false,
            onChange: () => {
              this.handleAppointWayChange();
            },
          },
          {
            value: 'split',
            allCustom: true,
          },
          // 指派车辆
          ...assignVehicle.form,
          // 指派员工
          ...assignStaff.form,
          // 指派车队
          ...assignFleet.form,
          {
            value: 'split',
            allCustom: true,
          },
          {
            label: '票据要求',
            value: 'isNeedBill',
            type: 'radio',
            default: '0',
          },
        ],
        rules: {
          appointWay: [
            { required: true, message: '请选中调度方式', trigger: 'blur' },
          ],
          isNeedBill: [
            { required: true, message: '请选择票据要求', trigger: 'blur' },
          ],
          // 指派车辆
          ...assignVehicle.rules,
          // 指派员工
          ...assignStaff.rules,
        },
      },
    };
  },
  methods: {
    async getOptions () {
      const enumsList = await getEnumList({
        codeType: 'PAYMENT_WAY,APPOINTWAY,IS_NEED_BILL',
      });
      const defaultBillData = await getDefaultBillInfo();
      this.baseForm.paymentWayOptions = enumsList[0].filter((item) => item.value !== '1');
      this.baseForm.appointWayOptions = enumsList[1];
      this.baseForm.isNeedBillOptions = enumsList[2];
      this.defaultBillData = defaultBillData;
    },
    // 设置 指派员工 - 跟单人员信息，同时同步操作结果到【归属】组件
    setFollowUpLocal (data) {
      this.setDispatchFollowUpLocal(data);
      this.$emit('setFollowUpLocal', data);
    },
    // 设置 指派员工 - 跟单人员信息
    setDispatchFollowUpLocal (data) {
      this.$refs.baseForm.setVal('localUserName', data.linkman || '');
      this.$refs.baseForm.setVal('localPhone', data.loginAcct || '');
      this.$refs.baseForm.setVal('localUser', data.userId || '');
    },
    // 调度方式改变（指派车辆：3，指派员工：4，指派车队：5）
    handleAppointWayChange (formDataContract) {
      const appointWay = this.$refs.baseForm.getVal('appointWay');
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: true,
        names: [
          'chooseVehicle', 'chooseDriver', 'paymentWay', 'oilCostPer', 'emptyOilCostPer', 'chooseTrailer',
          'localUserName', 'localPhone', 'guidePrice', 'totalFee',
          'toTenantName', 'acctName', 'acctNo',
          'isAgent', 'agentPhone', 'agentAccountName',
          'contractChart',
        ],
      });
      if (appointWay === '3') {
        // 指派车辆
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['chooseVehicle'],
        });
        this.handleVehicleChange(formDataContract);
      }
      if (appointWay === '4') {
        // 指派员工
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['localUserName', 'localPhone', 'guidePrice', 'totalFee'],
        });
      }
      if (appointWay === '5') {
        // 指派车队
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['toTenantName', 'acctName', 'acctNo', 'contractChart'],
        });

        this.$nextTick(() => {
          this.$refs.contract.getLevelAndSetSomeScales(3, formDataContract);
        });
      }
    },
    // 指派车辆
    ...assignVehicle.methods,
    // 指派车队
    ...assignFleet.methods,
    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        const dispatchInfo = {
          ['dispatchInfo.appointWay']: formData.appointWay,
          ['dispatchInfo.isNeedBill']: formData.isNeedBill,
        };

        /**
         * 图标需要提交的参数，在三个场景需要提交：
         * 1、指派车辆，车辆是自有车，成本模式选择了承包模式；
         * 2、指派车辆，车辆是非自有车；
         * 3、指派车队。
         */
        let contractFormData = null;
        // 指派车辆
        if (Number(formData.appointWay) === 3) {
          dispatchInfo['dispatchInfo.plateNumber'] = formData.chooseVehicle.plateNumber;
          dispatchInfo['dispatchInfo.vehicleCode'] = formData.chooseVehicle.vehicleCode;
          dispatchInfo['dispatchInfo.vehicleClass'] = formData.chooseVehicle.vehicleClass;
          dispatchInfo['dispatchInfo.licenceType'] = formData.chooseVehicle.licenceType;
          dispatchInfo['dispatchInfo.vehicleLength'] = formData.chooseVehicle.vehicleLength;
          dispatchInfo['dispatchInfo.vehicleStatus'] = formData.chooseVehicle.vehicleStatus;

          dispatchInfo['dispatchInfo.linkman'] = formData.chooseDriver.linkman;
          dispatchInfo['dispatchInfo.carDriverMan'] = formData.chooseDriver.linkman;
          dispatchInfo['dispatchInfo.carDriverId'] = formData.chooseDriver.userId;
          dispatchInfo['dispatchInfo.mobilePhone'] = formData.chooseDriver.loginAcct;
          dispatchInfo['dispatchInfo.carDriverPhone'] = formData.chooseDriver.loginAcct;

          if (Number(formData.chooseVehicle.licenceType) === 2) {
            // 牵引车
            dispatchInfo['dispatchInfo.trailerNumber'] = formData.dispatchTrailerInfo.trailerNumber;
            dispatchInfo['dispatchInfo.trailerId'] = formData.dispatchTrailerInfo.trailerId;
          }

          // 非自有车要提交是否代收，如果需要代收，还要提交代理人id，收款人手机，收款人
          if (formData.chooseVehicle.vehicleClass === 1) {
            // 自有车，提交 成本模式
            dispatchInfo['dispatchInfo.paymentWay'] = formData.paymentWay;
            if (Number(formData.paymentWay) === 1) {
              // 智能模式（这里不用这个，所以屏蔽掉，这个情况暂时不需要处理）
            }
            if (Number(formData.paymentWay) === 2) {
              // 报账模式，提交 载重油耗 和 空载油耗
              dispatchInfo['dispatchInfo.oilCostPer'] = formData.oilCostPer;
              dispatchInfo['dispatchInfo.emptyOilCostPer'] = formData.emptyOilCostPer;
            }
            if (Number(formData.paymentWay) === 3) {
              // 承包模式，提交 图表信息
              if (this.$refs.contract) {
                contractFormData = await this.$refs.contract.sub() || {};
              }
            }
          } else {
            // 非自有车
            if (formData.isAgent) {
              dispatchInfo['dispatchInfo.isAgent'] = formData.isAgent;
              dispatchInfo['dispatchInfo.agentId'] = formData.agentId;
              dispatchInfo['dispatchInfo.agentPhone'] = formData.agentPhone;
              dispatchInfo['dispatchInfo.agentAccountName'] = formData.agentAccountName;
            }
            // 非自有车，提交 图表信息
            if (this.$refs.contract) {
              contractFormData = await this.$refs.contract.sub() || {};
            }
          }

        }
        // 指派员工
        if (Number(formData.appointWay) === 4) {
          dispatchInfo['dispatchInfo.localUserName'] = formData.localUserName;
          dispatchInfo['dispatchInfo.localPhone'] = formData.localPhone;
          dispatchInfo['dispatchInfo.guidePrice'] = formData.guidePrice;
          dispatchInfo['dispatchInfo.totalFee'] = formData.totalFee;
        }
        // 指派车队
        if (Number(formData.appointWay) === 5) {
          dispatchInfo['dispatchInfo.toTenantName'] = formData.toTenantName;
          dispatchInfo['dispatchInfo.toTenantId'] = formData.toTenantId;
          dispatchInfo['dispatchInfo.acctName'] = formData.acctName;
          dispatchInfo['dispatchInfo.acctNo'] = formData.acctNo;

          if (this.$refs.contract) {
            contractFormData = await this.$refs.contract.sub() || {};
          }
        }

        // 自有车的 承包模式 或者是 非自有车，需要提交 图表信息
        if (contractFormData) {
          for (let item in contractFormData) {
            if (contractFormData[item]) {
              dispatchInfo[`dispatchInfo.${item}`] = contractFormData[item];
            }
          }
        }

        formData = dispatchInfo;
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }

      if (formData || cache) {
        let formDataContract = {};
        if (Number(formData.appointWay) === 5) {
          // 指派车队
          formDataContract = this.$refs.contract.cacheData();
        }
        // 指派车辆，自有车承包模式/非自有车
        if (Number(formData.appointWay) === 3) {
          if (formData.chooseVehicle.vehicleClass === 1) {
            // 自有车，成本模式为 承包模式
            if (Number(formData.paymentWay) === 3) {
              formDataContract = this.$refs.contract.cacheData();
            }
          } else {
            // 非自有车
            if (this.$refs.contract) {
              formDataContract = this.$refs.contract.cacheData();
            }
          }
        }

        formData = {
          chooseVehicle: formData.chooseVehicle,
          chooseDriver: formData.chooseDriver,
          chooseTrailer: formData.chooseTrailer,
          formDataContract,
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async init (data = {}) {

      await this.getOptions();
      // 提前调整数据，主要是处理城配订单修改时返回的订单详情数据
      adjustData(data);

      if (data.appointWay === undefined) {
        data.appointWay = this.baseForm.appointWayOptions[0].value;
      } else {
        data.appointWay = String(data.appointWay);
      }

      if (!data.isNeedBill) {
        data.isNeedBill = this.baseForm.isNeedBillOptions[0].value;
      } else {
        data.isNeedBill = String(data.isNeedBill);
      }

      this.$refs.baseForm.setVal(data);
      let formDataContract = null;
      if (data.formDataContract && Object.keys(data.formDataContract).length) {
        formDataContract = data.formDataContract;
      }
      this.handleAppointWayChange(formDataContract);
    },
  },
  activated () {
    assignVehicle.sendThis(this);
    assignStaff.sendThis(this);
    assignFleet.sendThis(this);
    this.getOptions();
  },
};
</script>

<style scoped lang="scss">
.choose-flex {
  display: flex;
}
::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
</style>
